module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/custom-domain-redirect/custom-domain-redirect.component.html
// module id = ./src/app/custom-domain-redirect/custom-domain-redirect.component.html
// module chunks = main